import { Component } from '@angular/core';
import { AuthService } from "../../_auth/auth.service";
import { Router } from '@angular/router';

@Component({
    selector: 'app-internal-landing-page',
    templateUrl: './internal-landing-page.component.html',
    styleUrl: './internal-landing-page.component.scss',
    standalone: false
})
export class InternalLandingPageComponent {
  public searchResults:any
  public onPageChange:any;
  public isAirmenAgentSearch: boolean;
  public sortOrder:string;
  public resetPagination:boolean
  public onAgentDelete:any;
  constructor(private authService: AuthService, public router: Router,){
    if(!this.authService.isInternalUser() && !this.authService.isInternalAdminUser()&& !this.authService.isTechSupportUser()){
      this.router.navigate(["/landing"]);
    }
  }

  handleSearch(event:any){
    this.searchResults = event;
  }

  handlePageChange(event:any){
  this.onPageChange= event;
  }

  sortOrderForSearch(event:any){
    this.sortOrder=event;
  }

  refreshOnAgentDelete(event:any){
    this.onAgentDelete=event;
  }

  IsSearchTypeAirmen(event:boolean)
  {
    this.isAirmenAgentSearch = event;
  }
  handleResetPagination(event:boolean){
    this.resetPagination =event;
  }

}
